import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import LabTrace from './LabTrace';
import reportWebVitals from './reportWebVitals';
import { Store } from './store/Store';
import theme from './theme/theme';

ReactDOM.render(
    <BrowserRouter>
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Provider store={Store}>
                <LabTrace />
            </Provider>
        </ThemeProvider>
    </BrowserRouter>,
    document.getElementById('root')
);

reportWebVitals();
